import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { Subscription } from "rxjs";

@Component({
  selector: 'resumen-admin',
  templateUrl: './resumen-admin.component.html',
  styleUrls: ['./resumen-admin.component.css']
})
export class ResumenAdminComponent implements OnInit {

  cantUsuarios: number;
  cantCursos:  number; 
  cantInstructores:  number;
  cantEmpresas:  number;
  subscripcionUsuario: Subscription
  usuario: any;
  token: string;

  constructor(
    private afs: AngularFirestore,
  ) { }

  ngOnInit(): void {
    this.token = JSON.parse(localStorage.getItem('token'))
    this.usuario = JSON.parse(localStorage.getItem('user'))
    console.log(this.usuario)
    this.afs.collection('global').doc('global').ref.get().then(doc => {
      const global = doc.data();

      this.cantCursos = global['cantidadCursos'],
      this.cantInstructores = global['cantidadInstructores'],
      this.cantEmpresas = global['cantidadEmpresas']
      this.getCantUsuarios()
    });
  }

  async getCantUsuarios() {
    const doc = await this.afs.collection("global").doc("indiceUsuarios").ref.get();
    const data = doc.data();
    this.cantUsuarios = Object.keys(Object.assign({},data)).length
  }
}
